// Central place for store / external app links.
//
// PLAY_STORE_ID is the real Play Console package id for Holy Words
// (bible.holywords.app). Set via REACT_APP_PLAY_STORE_ID in frontend/.env;
// the fallback matches the live listing. Override the full URL at build
// time with REACT_APP_PLAY_STORE_URL if ever needed.
export const PLAY_STORE_ID =
  process.env.REACT_APP_PLAY_STORE_ID || "bible.holywords.app";

export const PLAY_STORE_URL =
  process.env.REACT_APP_PLAY_STORE_URL ||
  `https://play.google.com/store/apps/details?id=${PLAY_STORE_ID}`;

// Open the Play Store listing on the rating/review surface. On Android we
// first try the native market:// deep link (opens the Play Store app
// straight to the listing where the user can leave a star rating), then
// fall back to the web URL for everyone else.
export function openPlayStoreRating() {
  const isAndroid = /android/i.test(navigator.userAgent || "");
  if (isAndroid) {
    try {
      window.location.href = `market://details?id=${PLAY_STORE_ID}`;
      // Fallback to web if the Play Store app didn't intercept the deep link.
      setTimeout(() => {
        window.open(PLAY_STORE_URL, "_blank", "noopener");
      }, 600);
      return;
    } catch (_) {
      /* fall through to web */
    }
  }
  window.open(PLAY_STORE_URL, "_blank", "noopener");
}
